'use client';

export interface User {
  id: string;
  email: string;
  name: string;
  role: 'admin' | 'analyst' | 'viewer';
  company: string;
  initials: string;
}

// Built-in users — admin is the platform owner with full edit control
export const USERS: User[] = [
  {
    id: 'user-admin',
    email: 'admin@globalatlas.io',
    name: 'Platform Admin',
    role: 'admin',
    company: 'GlobalAtlas',
    initials: 'GA',
  },
  {
    id: 'user-001',
    email: 'marcus.klein@acmecorp-risk.com',
    name: 'Marcus Klein',
    role: 'analyst',
    company: 'Acme Corp',
    initials: 'MK',
  },
  {
    id: 'user-002',
    email: 'sarah.chen@meridian-capital.com',
    name: 'Sarah Chen',
    role: 'analyst',
    company: 'Meridian Capital',
    initials: 'SC',
  },
  {
    id: 'user-003',
    email: 'james.okafor@nexus-logistics.com',
    name: 'James Okafor',
    role: 'viewer',
    company: 'Nexus Logistics',
    initials: 'JO',
  },
];

// Passwords map (email → password)
const PASSWORDS: Record<string, string> = {
  'admin@globalatlas.io': 'Admin#Atlas2026',
  'marcus.klein@acmecorp-risk.com': 'Atlas#Demo2026',
  'sarah.chen@meridian-capital.com': 'Meridian#2026',
  'james.okafor@nexus-logistics.com': 'Nexus#2026',
};

export function authenticate(email: string, password: string): User | null {
  const user = USERS.find(u => u.email.toLowerCase() === email.toLowerCase());
  if (!user) return null;
  if (PASSWORDS[user.email] !== password) return null;
  return user;
}

export function getStoredUser(): User | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem('ga_user');
    if (!raw) return null;
    return JSON.parse(raw) as User;
  } catch {
    return null;
  }
}

export function storeUser(user: User): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem('ga_user', JSON.stringify(user));
}

export function clearUser(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem('ga_user');
}

export function isAdmin(user: User | null): boolean {
  return user?.role === 'admin';
}
